import { Select } from 'antd';

import { LabelText, Wrapper } from './AcademiesSelector.styles';

import { useUserAcademies } from '@/hooks';
import { handleInputValue } from '@/utils';

type Props = {
  value?: string;
  labelText?: string;
  onChange?: (value: string) => void;
};

export const AcademiesSelector: React.FC<Props> = ({ value, labelText, onChange }) => {
  const { academies = [], isLoading } = useUserAcademies();

  if (academies.length <= 1) return null;

  return (
    <Wrapper>
      {labelText && <LabelText>{labelText}</LabelText>}
      <Select
        onChange={onChange}
        value={handleInputValue(value)}
        loading={isLoading}
        options={academies.map(({ _id, name }) => ({
          label: name,
          value: _id
        }))}
      />
    </Wrapper>
  );
};
